const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the comment count component
 * @argument {MainComments} MainComments injected to gain access to the MainComments resource
 */
app.directive('commentCount', ['Application', 'MainComments', function (Application, MainComments) {
  return {
    restrict: "E",
    replace: true,
    scope : {
    },
    template: require('../../templates/directives/comment-count.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.contentId = null;
      self.contentType = null;
      self.show = false;

      self.initialize = function() {
        var options = {};
        options[self.contentType] = self.contentId;

        MainComments.count(options, function (data) {
          self.amount = data.count;
        }, function (err) {
          console.log('error setting comment count: ', err);
        });
      };

      self.parseUrl = function (url) {
        var url = url;
        if (!/view/g.test(url) || /overview/g.test(url) || /host/g.test(url)) {
          self.show = false;
          return;
        }

        var splitUrl = url.split('/');

        // tracks must be first as it may contain other types in the url
        if (/tracks/g.test(url)) {
          self.contentType = 'track';
          for (var i = 0; i < splitUrl; i++) {
            if (splitUrl[i] === 'tracks') {
              self.contentId = splitUrl[i + 1];
              return;
            }
          }
          return;
        }

        self.contentId = splitUrl[splitUrl.length - 1];
        if (/articles/g.test(url)) {
          self.contentType = 'article';
          return;
        }
        if (/videos/g.test(url)) {
          self.contentType = 'media';
          return;
        }
        if (/files/g.test(url)) {
          self.contentType = 'media';
          return;
        }
        if (/events/g.test(url)) {
          self.contentType = 'event';
          return;
        }
        self.show = false;
      };

      $scope.$on('$routeChangeSuccess', function (event, current, previous) {
        self.contentType = null;
        self.contentId = null;
        self.parseUrl(Application.navigation.getUrl());
        if (self.contentType && self.contentId) {
          if (self.contentType === 'event') {
            return;
          }
          self.initialize();
          self.show = true;
        }
      });

      self.parseUrl(Application.navigation.getUrl());
      if (self.contentType && self.contentId) {
        if (self.contentType === 'event') {
          return;
        }
        self.initialize();
        self.show = true;
      }

    }],
    controllerAs: 'commentsCount'
  }
}]);
